/**
 * 招待受諾ページ - 公開ページ
 */

import type { PublicInvitation } from "hooks/useInvitationApi";
import type { FC } from "react";
import { InvitationContent } from "routes/InvitationPage/components/InvitationContent";
import { InvitationError } from "routes/InvitationPage/components/InvitationError";
import { InvitationLoading } from "routes/InvitationPage/components/InvitationLoading";

type InvitationPageProps = {
  invitation: PublicInvitation | null;
  loading: boolean;
  error: { status: number; message: string } | null;
  token: string;
};

export const InvitationPage: FC<InvitationPageProps> = ({
  invitation,
  loading,
  error,
  token,
}) => {
  if (loading) {
    return <InvitationLoading />;
  }

  if (error || !invitation) {
    return <InvitationError error={error} />;
  }

  return <InvitationContent invitation={invitation} token={token} />;
};
